
import { defineComponent, ref, computed, onMounted, watch } from 'vue';

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {

    onMounted(() => {
      //
    })

    return {
    };
  },
});
